import type { Release } from '../releases';

export default {
  id: '2026-11-04-budget-tool-cost',
  at: '2026-11-04T12:15:00Z',
  title: 'Инструмент — в себестоимости проекта',
  modules: ['budget', 'warehouse'],
  items: [
    'В «Марже проекта» появилась карточка «Инструмент»: дни на руках по проекту выдачи, умноженные на ставку за день экземпляра, и затраты на ремонт инструмента.',
    'Ниже — разбивка по месяцам. Экземпляры без ставки в сумму не входят, их число видно в подписи.',
    'Ремонт относится на проект, где инструмент работал последним перед ремонтом.',
  ],
  why: 'Стоимость инструмента считалась на складе, но в себестоимость проекта не попадала, и её сводили вручную. Теперь она видна рядом с остальными затратами проекта.',
  link: '/projects',
} satisfies Release;
